// extracted by mini-css-extract-plugin
export default {"loader":"loader_LEhf","loader-loaded":"loader-loaded_Fb5L"};